import { render } from "./SignInCard.vue?vue&type=template&id=645f6b0a"
import script from "./SignInCard.vue?vue&type=script&lang=js"
export * from "./SignInCard.vue?vue&type=script&lang=js"

import "./SignInCard.vue?vue&type=style&index=0&id=645f6b0a&lang=scss"

import exportComponent from "D:\\1.Server\\Repositories\\asptmr-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QCheckbox,QSpace,QBtn});
